/**
 * State used in rendering EmptySwatch
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
